// import React from "react";
// import Draggable from "react-draggable";
// import { Typography } from "@mui/material";
// const DraggableCards = ({ children }) => {
//   return (
//     <div>
//       {React.Children.map(
//         children,
//         (child, index) =>
//           // <Draggable>
//           child?.props?.title && (
//             <div key={index} className="rounded-lg shadow-lg m-3 p-3">
//               <div className="text-center text-xl mb-3">
//                 <Typography varient="h3">{child.props.title}</Typography>
//               </div>
//               <div className="text-center text-xl mb-3">
//                 <Typography varient="h2">{child.props.subtitle}</Typography>
//               </div>
//               <div className="flex flex-col justify-center items-center h-full">
//                 {child}
//               </div>
//             </div>
//           )
//         // </Draggable>
//       )}
//     </div>
//   );
// };

// export default DraggableCards;
import React from "react";
import Draggable from "react-draggable";
import { Typography } from "@mui/material";

const DraggableCards = ({ children }) => {
  return (
    <div>
      {React.Children.map(children, (child, index) =>
        child?.props?.title ? (
          <div key={index} className="rounded-lg shadow-lg m-3 p-3">
            <div className="text-center mb-3">
              <Typography
                variant="h4"
                fontFamily="monospace"
                component="h4"
                sx={{ fontWeight: "bold" }}
              >
                {child.props.title}
              </Typography>
            </div>
            <div className="text-center mb-3">
              <Typography variant="subtitle1" fontFamily="monospace">
                {child.props.subtitle}
              </Typography>
            </div>
            <div className="flex flex-col justify-center items-center h-full">
              {child}
            </div>
          </div>
        ) : null
      )}
    </div>
  );
};

export default DraggableCards;
